import styled from 'styled-components';
import { Modal } from '@hud/web-components/Modal/Modal';
import {
  textMediumSemiBold,
  textSmallSemiBold,
} from '@hud/web-components/DesignSystem/Typography';

export const StyledSetChannelDialog = styled(Modal)`
  padding: var(--space-0);
  max-width: 500px;
  background: var(--black-200);
  border-radius: var(--border-radius-button);

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-150) var(--space-200);
    border-bottom: 1px solid var(--border-color-default);
  }

  .modal-title {
    ${textMediumSemiBold};
    color: var(--text-standard-primary);
    margin: var(--space-0);
  }

  .modal-content {
    padding: var(--space-200);
    display: flex;
    flex-direction: column;
    gap: var(--space-300);
  }

  .modal-actions {
    display: flex;
    padding: var(--space-150) var(--space-200);
    justify-content: space-between;
    align-items: center;

    gap: var(--space-200);
    .cancel {
      margin-left: auto;
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: var(--space-250);
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: var(--space-150);
    color: var(--black-800);

    .form-label {
      ${textSmallSemiBold}
    }
  }
`;
